import { Fetch, FetchBody, FetchMethod, InterceptorFunctions } from "../api/fetch/fetch.types";

export const getFetchRequestData = async (requestOrigin: Request) => {
  const request = requestOrigin.clone();

  let body: FetchBody;
  const contentType = requestOrigin.headers.get('Content-Type');
  try {
    if (contentType == 'application/json') {
      body = await request.json();
    } else if (contentType?.includes('multipart/form-data')) {
      body = await request.formData();
    } else {
      body = await request.text();
    }
  } catch (err) {
    body = await request.text();
  }
  return {
    url: request.url,
    method: request.method as FetchMethod,
    body
  }
}

const fetchProxy = (interceptorFunctions: InterceptorFunctions) => {
  return async (target: Fetch, thisArg: any, args: Parameters<Fetch>) => {
    // Requestify the params
    let request: Request;
    if (args[0] instanceof Request) {
      request = args[0];
    } else {
      request = new Request(args[0], args[1]);
    }

    try {
      const { url, method, body } = await getFetchRequestData(request);
      interceptorFunctions.beforeFetch(url, method, body);
      let response = await target(...args);
      interceptorFunctions.afterFetch(url, method, body, response.clone());
      return response;
    } catch (error) {
      throw error;
    }
  };
}

export const createInterceptableFetchProxy = (fetch: typeof window.fetch, interceptorFunctions: InterceptorFunctions) => {
  return new Proxy<Fetch>(fetch, {
    apply: fetchProxy(interceptorFunctions)
  });
}
